<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7618_19488)">
      <path d="M12.4331 24.9922L15.5388 23.9922L18.6444 24.9922V29.875H12.4331V24.9922Z"
            fill="url(#paint0_linear_7618_19488)"
      />
      <path d="M12.4331 24.9922L15.5388 23.9922L18.6444 24.9922V29.875H12.4331V24.9922Z"
            fill="url(#paint1_linear_7618_19488)"
      />
      <path d="M12.4331 24.9922L15.5388 23.9922L18.6444 24.9922V29.875H12.4331V24.9922Z"
            fill="url(#paint2_linear_7618_19488)"
      />
      <path d="M5.55859 4.8C5.55859 3.2536 6.8122 2 8.35859 2H22.6648C24.2112 2 25.4648 3.2536 25.4648 4.8V22.1922C25.4648 23.7386 24.2112 24.9922 22.6648 24.9922H8.35859C6.8122 24.9922 5.55859 23.7386 5.55859 22.1922V4.8Z"
            fill="url(#paint3_linear_7618_19488)"
      />
      <path d="M5.55859 4.8C5.55859 3.2536 6.8122 2 8.35859 2H22.6648C24.2112 2 25.4648 3.2536 25.4648 4.8V22.1922C25.4648 23.7386 24.2112 24.9922 22.6648 24.9922H8.35859C6.8122 24.9922 5.55859 23.7386 5.55859 22.1922V4.8Z"
            fill="url(#paint4_linear_7618_19488)"
      />
      <path d="M5.55859 4.8C5.55859 3.2536 6.8122 2 8.35859 2H22.6648C24.2112 2 25.4648 3.2536 25.4648 4.8V22.1922C25.4648 23.7386 24.2112 24.9922 22.6648 24.9922H8.35859C6.8122 24.9922 5.55859 23.7386 5.55859 22.1922V4.8Z"
            fill="url(#paint5_linear_7618_19488)"
      />
      <path d="M5.55859 4.8C5.55859 3.2536 6.8122 2 8.35859 2H22.6648C24.2112 2 25.4648 3.2536 25.4648 4.8V22.1922C25.4648 23.7386 24.2112 24.9922 22.6648 24.9922H8.35859C6.8122 24.9922 5.55859 23.7386 5.55859 22.1922V4.8Z"
            fill="url(#paint6_radial_7618_19488)"
      />
      <path d="M9.02734 5.10203C9.02734 4.88873 9.20026 4.71582 9.41356 4.71582H21.6561C21.8694 4.71582 22.0423 4.88873 22.0423 5.10203C22.0423 5.31533 21.8694 5.48825 21.6561 5.48825H9.41356C9.20026 5.48825 9.02734 5.31533 9.02734 5.10203Z"
            fill="url(#paint7_linear_7618_19488)"
      />
      <path d="M9.02734 5.10203C9.02734 4.88873 9.20026 4.71582 9.41356 4.71582H21.6561C21.8694 4.71582 22.0423 4.88873 22.0423 5.10203C22.0423 5.31533 21.8694 5.48825 21.6561 5.48825H9.41356C9.20026 5.48825 9.02734 5.31533 9.02734 5.10203Z"
            fill="url(#paint8_radial_7618_19488)"
      />
      <rect x="9.02734"
            y="13.5947"
            width="13.0149"
            height="7.8737"
            rx="1"
            fill="#C13965"
      />
      <rect x="9.02734"
            y="13.5947"
            width="13.0149"
            height="7.8737"
            rx="1"
            fill="url(#paint9_linear_7618_19488)"
      />
      <rect x="9.02734"
            y="13.5947"
            width="13.0149"
            height="7.8737"
            rx="1"
            fill="url(#paint10_linear_7618_19488)"
      />
      <rect x="9.02734"
            y="13.5947"
            width="13.0149"
            height="7.8737"
            rx="1"
            fill="url(#paint11_linear_7618_19488)"
      />
      <rect x="9.02734"
            y="13.5947"
            width="13.0149"
            height="7.8737"
            rx="1"
            fill="url(#paint12_linear_7618_19488)"
            fill-opacity="0.54"
      />
      <path d="M11.6912 9.875H17.3316C17.7248 9.875 18.0117 10.247 17.9119 10.6273L16.4085 16.3551C16.3393 16.6189 16.1009 16.8028 15.8282 16.8028H10.1103C9.71392 16.8028 9.42647 16.4252 9.53193 16.0431L11.1128 10.3154C11.1846 10.0552 11.4213 9.875 11.6912 9.875Z"
            fill="url(#paint13_radial_7618_19488)"
      />
      <rect x="9.02734"
            y="6.9502"
            width="13.0149"
            height="4.00281"
            rx="2.0014"
            fill="#3B2A4C"
      />
      <rect x="9.02734"
            y="6.9502"
            width="13.0149"
            height="4.00281"
            rx="2.0014"
            fill="url(#paint14_radial_7618_19488)"
      />
      <path d="M13.3438 6.9502H19.1641L17.6719 11.4736H13.3438V6.9502Z"
            fill="#D4CCD8"
      />
      <path d="M13.3438 6.9502H19.1641L17.6719 11.4736H13.3438V6.9502Z"
            fill="url(#paint15_linear_7618_19488)"
      />
      <path d="M13.3438 6.9502H19.1641L17.6719 11.4736H13.3438V6.9502Z"
            fill="url(#paint16_radial_7618_19488)"
            fill-opacity="0.71"
      />
      <path d="M17.3516 16.2314H10.9375C11.2375 14.9447 13.8438 12.0078 15.1094 10.7002L17.3516 16.2314Z"
            fill="#D9CFE2"
      />
      <path d="M17.3516 16.2314H10.9375C11.2375 14.9447 13.8438 12.0078 15.1094 10.7002L17.3516 16.2314Z"
            fill="url(#paint17_linear_7618_19488)"
      />
      <path d="M17.3516 16.2314H10.9375C11.2375 14.9447 13.8438 12.0078 15.1094 10.7002L17.3516 16.2314Z"
            fill="url(#paint18_linear_7618_19488)"
      />
      <path d="M15.0625 10.728C16.025 9.57135 18.3281 7.23145 18.8125 6.9502H20.1641L18.144 15.6284C18.0597 15.9907 17.7368 16.2471 17.3648 16.2471H17.1562C16.7422 14.9256 15.5117 12.1428 14.9805 10.9768L15.0625 10.728Z"
            fill="#DAD3E1"
      />
      <path d="M15.0625 10.728C16.025 9.57135 18.3281 7.23145 18.8125 6.9502H20.1641L18.144 15.6284C18.0597 15.9907 17.7368 16.2471 17.3648 16.2471H17.1562C16.7422 14.9256 15.5117 12.1428 14.9805 10.9768L15.0625 10.728Z"
            fill="url(#paint19_linear_7618_19488)"
      />
      <path d="M15.0625 10.728C16.025 9.57135 18.3281 7.23145 18.8125 6.9502H20.1641L18.144 15.6284C18.0597 15.9907 17.7368 16.2471 17.3648 16.2471H17.1562C16.7422 14.9256 15.5117 12.1428 14.9805 10.9768L15.0625 10.728Z"
            fill="url(#paint20_linear_7618_19488)"
      />
      <path d="M15.0625 10.728C16.025 9.57135 18.3281 7.23145 18.8125 6.9502H20.1641L18.144 15.6284C18.0597 15.9907 17.7368 16.2471 17.3648 16.2471H17.1562C16.7422 14.9256 15.5117 12.1428 14.9805 10.9768L15.0625 10.728Z"
            fill="url(#paint21_radial_7618_19488)"
      />
      <path d="M15.0625 10.728C16.025 9.57135 18.3281 7.23145 18.8125 6.9502H20.1641L18.144 15.6284C18.0597 15.9907 17.7368 16.2471 17.3648 16.2471H17.1562C16.7422 14.9256 15.5117 12.1428 14.9805 10.9768L15.0625 10.728Z"
            fill="url(#paint22_linear_7618_19488)"
      />
      <path d="M10.3949 15.6167L12.4375 6.9502H13.7578L15.5595 10.6582C15.5743 10.6888 15.5821 10.7223 15.5821 10.7563C15.5821 10.8154 15.5605 10.8703 15.5193 10.9126C15.0825 11.3603 12.4771 14.062 11.1827 16.1136C11.1363 16.1871 11.0564 16.2314 10.9695 16.2314H10.8816C10.5591 16.2314 10.3209 15.9306 10.3949 15.6167Z"
            fill="#D5CEDC"
      />
      <path d="M10.3949 15.6167L12.4375 6.9502H13.7578L15.5595 10.6582C15.5743 10.6888 15.5821 10.7223 15.5821 10.7563C15.5821 10.8154 15.5605 10.8703 15.5193 10.9126C15.0825 11.3603 12.4771 14.062 11.1827 16.1136C11.1363 16.1871 11.0564 16.2314 10.9695 16.2314H10.8816C10.5591 16.2314 10.3209 15.9306 10.3949 15.6167Z"
            fill="url(#paint23_linear_7618_19488)"
      />
      <path d="M10.3949 15.6167L12.4375 6.9502H13.7578L15.5595 10.6582C15.5743 10.6888 15.5821 10.7223 15.5821 10.7563C15.5821 10.8154 15.5605 10.8703 15.5193 10.9126C15.0825 11.3603 12.4771 14.062 11.1827 16.1136C11.1363 16.1871 11.0564 16.2314 10.9695 16.2314H10.8816C10.5591 16.2314 10.3209 15.9306 10.3949 15.6167Z"
            fill="url(#paint24_radial_7618_19488)"
      />
      <path d="M10.3949 15.6167L12.4375 6.9502H13.7578L15.5595 10.6582C15.5743 10.6888 15.5821 10.7223 15.5821 10.7563C15.5821 10.8154 15.5605 10.8703 15.5193 10.9126C15.0825 11.3603 12.4771 14.062 11.1827 16.1136C11.1363 16.1871 11.0564 16.2314 10.9695 16.2314H10.8816C10.5591 16.2314 10.3209 15.9306 10.3949 15.6167Z"
            fill="url(#paint25_linear_7618_19488)"
      />
      <path d="M10.3949 15.6167L12.4375 6.9502H13.7578L15.5595 10.6582C15.5743 10.6888 15.5821 10.7223 15.5821 10.7563C15.5821 10.8154 15.5605 10.8703 15.5193 10.9126C15.0825 11.3603 12.4771 14.062 11.1827 16.1136C11.1363 16.1871 11.0564 16.2314 10.9695 16.2314H10.8816C10.5591 16.2314 10.3209 15.9306 10.3949 15.6167Z"
            fill="url(#paint26_linear_7618_19488)"
      />
      <path d="M10.3949 15.6167L12.4375 6.9502H13.7578L15.5595 10.6582C15.5743 10.6888 15.5821 10.7223 15.5821 10.7563C15.5821 10.8154 15.5605 10.8703 15.5193 10.9126C15.0825 11.3603 12.4771 14.062 11.1827 16.1136C11.1363 16.1871 11.0564 16.2314 10.9695 16.2314H10.8816C10.5591 16.2314 10.3209 15.9306 10.3949 15.6167Z"
            fill="url(#paint27_linear_7618_19488)"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_7618_19488"
                      x1="14.4008"
                      y1="28.3912"
                      x2="17.2787"
                      y2="28.3912"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B399C4" />
        <stop offset="1"
              stop-color="#D8C5E7"
        />
      </linearGradient>
      <linearGradient id="paint1_linear_7618_19488"
                      x1="18.6444"
                      y1="24.5997"
                      x2="17.37"
                      y2="27.2035"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.240947"
              stop-color="#9F799F"
        />
        <stop offset="1"
              stop-color="#C2A5CC"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint2_linear_7618_19488"
                      x1="12.4331"
                      y1="28.2998"
                      x2="14.8576"
                      y2="28.2998"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#916593" />
        <stop offset="1"
              stop-color="#AA8EBA"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint3_linear_7618_19488"
                      x1="15.5117"
                      y1="2"
                      x2="15.5117"
                      y2="24.9922"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E93D8F" />
        <stop offset="1"
              stop-color="#FE3F5E"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_7618_19488"
                      x1="5.55859"
                      y1="16.7353"
                      x2="8.31008"
                      y2="16.7353"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D12C44" />
        <stop offset="1"
              stop-color="#D12C44"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_7618_19488"
                      x1="8.31008"
                      y1="25.7"
                      x2="8.31008"
                      y2="23.195"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D12C44" />
        <stop offset="1"
              stop-color="#D12C44"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint6_radial_7618_19488"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(24.0051 8.11713) rotate(90) scale(13.0664 1.44564)"
      >
        <stop stop-color="#FD5E97" />
        <stop offset="0.865859"
              stop-color="#F95A93"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint7_linear_7618_19488"
                      x1="9.02734"
                      y1="5.10203"
                      x2="22.2033"
                      y2="5.10203"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BA3961" />
        <stop offset="1"
              stop-color="#BD3961"
        />
      </linearGradient>
      <radialGradient id="paint8_radial_7618_19488"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(21.9611 4.7911) rotate(149.3) scale(0.425012 0.376527)"
      >
        <stop stop-color="#C8506D" />
        <stop offset="1"
              stop-color="#C8506D"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint9_linear_7618_19488"
                      x1="9.60436"
                      y1="13.1562"
                      x2="11.2946"
                      y2="17.7015"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#93224A" />
        <stop offset="1"
              stop-color="#93224A"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint10_linear_7618_19488"
                      x1="9.02734"
                      y1="18.3044"
                      x2="9.28549"
                      y2="18.3044"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A51D4B" />
        <stop offset="1"
              stop-color="#A51D4B"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint11_linear_7618_19488"
                      x1="9.28549"
                      y1="21.8459"
                      x2="9.28549"
                      y2="21.1279"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A51D4B" />
        <stop offset="1"
              stop-color="#A51D4B"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint12_linear_7618_19488"
                      x1="21.9824"
                      y1="21.1279"
                      x2="21.7245"
                      y2="21.1279"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CF4A6D" />
        <stop offset="1"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#C13965"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint13_radial_7618_19488"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(9.87386 12.0727) rotate(11.976) scale(2.37298 15.7207)"
      >
        <stop offset="0.12891"
              stop-color="#BF2657"
              stop-opacity="0"
        />
        <stop offset="0.538474"
              stop-color="#971C4A"
        />
      </radialGradient>
      <radialGradient id="paint14_radial_7618_19488"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.2669 9.3771) rotate(0.562192) scale(6.3861 3.31336)"
      >
        <stop offset="0.508217"
              stop-color="#211133"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#211133"
        />
      </radialGradient>
      <linearGradient id="paint15_linear_7618_19488"
                      x1="16.75"
                      y1="9.04395"
                      x2="16.2539"
                      y2="8.59082"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CAC5CD" />
        <stop offset="1"
              stop-color="#CAC5CD"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint16_radial_7618_19488"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.7645 10.7593) rotate(-67.3532) scale(4.79058 5.79945)"
      >
        <stop offset="0.582996"
              stop-color="#81788A"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#8B8195"
        />
      </radialGradient>
      <linearGradient id="paint17_linear_7618_19488"
                      x1="16.9531"
                      y1="15.1221"
                      x2="16.3438"
                      y2="15.3564"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.281191"
              stop-color="#BBAEC9"
        />
        <stop offset="1"
              stop-color="#CDC2D8"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint18_linear_7618_19488"
                      x1="15.2656"
                      y1="16.3877"
                      x2="15.2656"
                      y2="14.9814"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B17FCC" />
        <stop offset="1"
              stop-color="#CBB1E5"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint19_linear_7618_19488"
                      x1="18.8437"
                      y1="13.1221"
                      x2="16.6562"
                      y2="12.6221"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0817488"
              stop-color="#F3EAFA"
        />
        <stop offset="1"
              stop-color="#DED7E5"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint20_linear_7618_19488"
                      x1="18.1094"
                      y1="16.2471"
                      x2="18.1094"
                      y2="15.2471"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B587CD" />
        <stop offset="1"
              stop-color="#DDCEEE"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint21_radial_7618_19488"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.3906 12.7783) rotate(-54.0911) scale(6.97999 10.3259)"
      >
        <stop offset="0.836559"
              stop-color="#A49AB0"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#867994"
        />
      </radialGradient>
      <linearGradient id="paint22_linear_7618_19488"
                      x1="16.0625"
                      y1="13.6249"
                      x2="16.25"
                      y2="13.5468"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#AC9CBC" />
        <stop offset="1"
              stop-color="#AC9CBC"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint23_linear_7618_19488"
                      x1="10.7344"
                      y1="11.4658"
                      x2="12.4062"
                      y2="11.9033"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A499A6" />
        <stop offset="1"
              stop-color="#BDB5C3"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint24_radial_7618_19488"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(13.0625 13.7705) rotate(-140.08) scale(0.499145 4.87993)"
      >
        <stop offset="0.230653"
              stop-color="#E2D7EE"
        />
        <stop offset="1"
              stop-color="#E2D7EE"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint25_linear_7618_19488"
                      x1="15.1562"
                      y1="9.5752"
                      x2="13.7969"
                      y2="10.0439"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DCD5DE" />
        <stop offset="1"
              stop-color="#DCD5DE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint26_linear_7618_19488"
                      x1="12.4532"
                      y1="6.67105"
                      x2="12.9817"
                      y2="7.61962"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#685B75" />
        <stop offset="0.846114"
              stop-color="#685B75"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint27_linear_7618_19488"
                      x1="13.9895"
                      y1="12.7442"
                      x2="13.7847"
                      y2="12.5627"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BEA3D7" />
        <stop offset="1"
              stop-color="#BEA3D7"
              stop-opacity="0"
        />
      </linearGradient>
      <clipPath id="clip0_7618_19488">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
